import React from 'react';
import styles from './Chat.module.css';

export default function ServiceResultCard({data}) {
    if (!data) return null;
    if (['facility', 'pilot_status', 'rct_city'].includes(data.query_type)) {
        const title = data.query_type === 'pilot_status' ? 'RCT 试点登记' : data.query_type === 'rct_city' ? 'RCT 城市登记' : 'RSV 接种机构登记';
        return <section className={styles.clinic_card} aria-label={title}>
            <div className={styles.clinic_card_title}>{title}</div>
            <div className={styles.clinic_card_message}>以下为登记信息，未按您的当前位置排序。</div>
            {data.data.map((row, index) => <div className={styles.clinic_item} key={row.site_id || index}>
                <div className={styles.clinic_info} style={{gridColumn: '1 / -1'}}>
                    <div className={styles.clinic_name}>{row.facility_name || row.city}</div>
                    <div className={styles.clinic_meta}>{row.address || [row.city, row.district].filter(Boolean).join(' · ')}</div>
                    <div className={styles.clinic_meta}>电话：{row.contact_phone || '未登记'}</div>
                    {row.eligibility_restriction && <div className={styles.clinic_meta}>服务限制：{row.eligibility_restriction}</div>}
                    {row.pilot_status && <div className={styles.clinic_meta}>试点状态：{row.pilot_status}</div>}
                    <div className={styles.clinic_meta}>资料截至：{row.source_as_of && row.source_as_of !== 'unknown' ? row.source_as_of : '未提供'}</div>
                </div>
            </div>)}
            {!data.data.length && <div>{data.message || '暂无匹配登记记录'}</div>}
            <div className={styles.clinic_card_message}>{data.notice}</div>
        </section>;
    }
    if (data.query_type !== 'price') return null;
    return <section className={styles.clinic_card} aria-label="尼塞韦单抗登记价格">
        <div className={styles.clinic_card_title}>尼塞韦单抗登记价格</div>
        {Array.isArray(data.data) && data.data.map((row, index) => <div className={styles.clinic_item} key={row.price_id || index}>
            <div className={styles.clinic_info}>
                <div className={styles.clinic_name}>{row.specification}</div>
                <div>{row.price_cny ?? '未登记'} {row.price_unit}</div>
                <div className={styles.clinic_meta}>来源：{row.source || '登记库'}；生效日期：{row.effective_date === 'unknown' ? '未提供' : row.effective_date}</div>
            </div>
        </div>)}
        <div className={styles.clinic_card_message}>{data.scope}</div>
        <div className={styles.clinic_card_message}>{data.notice || data.message}</div>
    </section>;
}
